import model from '../models-v2/bookkeeping/zus-declarations';
import beforeZusEnterMiddleware from '../router/beforeZusEnterMiddleware';

export default [
  {
    path: '/zus/declarations',
    name: 'zus-declarations',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../views/pages/zus-declarations/ZusDeclarationsTopRightSection.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Deklaracje ZUS', url: '/zus/declarations' },
        { title: 'Lista', url: '/zus/declarations' },
      ],
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
    beforeEnter: beforeZusEnterMiddleware,
  },
  {
    path: '/zus/declarations/add/:zuspackage_id(\\d+)?',
    name: 'zus-declarations-add',
    component: () => import('../views/pages/declarations/zus/ZusDeclarationForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'Deklaracje ZUS', url: '/zus/declarations' },
        { title: 'Lista', url: '/zus/declarations' },
      ],
    },
    props: (route) => ({ zuspackage_id: Number(route.params.zuspackage_id) }),
    beforeEnter: beforeZusEnterMiddleware,
  },
  {
    path: '/zus/declarations/edit/:id',
    name: 'zus-declarations-edit',
    component: () => import('../views/pages/declarations/zus/ZusDeclarationForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'Deklaracje ZUS', url: '/zus/declarations' },
        { title: 'Lista', url: '/zus/declarations' },
      ],
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
    beforeEnter: beforeZusEnterMiddleware,
  },
  {
    path: '/zus/declarations/show/:id',
    name: 'zus-declarations-show',
    component: () => import('../views/pages/declarations/zus/ZusDeclarationForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'Deklaracje ZUS', url: '/zus/declarations' },
        { title: 'Lista', url: '/zus/declarations' },
      ],
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
    beforeEnter: beforeZusEnterMiddleware,
  },
];
